export const state = () => ({})

export const mutations = {}

export const actions = {
  async forgetPassword ({ commit }, email) {
    return await this.$axios.$post('send-password-reset', { email })
  },
  async resetPassword ({ commit }, payload) {
    return await this.$axios.$post('reset-password', payload)
  }
}
